import { defineMessages } from 'react-intl'


export default defineMessages({
  ariaLabel: {
    defaultMessage: 'Close modal',
    id: 'modal-content.aria-label',
  },
})
